import type { BodyTokens } from './types';

export const body: BodyTokens = {
  letterSpacings: {
    base: null,
    small: null,
    xSmall: null,
    xxSmall: null,
  },
};
